import { render, staticRenderFns } from "./AssessmentPaymentCallback.vue?vue&type=template&id=321786f0&scoped=true"
import script from "./AssessmentPaymentCallback.vue?vue&type=script&lang=js"
export * from "./AssessmentPaymentCallback.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPaymentCallback.vue?vue&type=style&index=0&id=321786f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321786f0",
  null
  
)

export default component.exports